import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';

import ButtonViewGlossary from '../../../atoms/button-view-glossary';
import InteractiveElement from '../../../atoms/interactive-element';
import styles from './style-box.module.scss';
import { STYLE_BOX_MODELS } from '../../../../shared/screener-constants';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import { styleBoxUpdate } from '../../../../stores/screener/screener-redux-store';

const className = augmentClassName(styles);

export const StyleBox = ({ modelKey, filter, updateValue }) => {
  return (
    <Col {...className('root', 'mx-6')}>
      <Row {...className('head-row', 'align-items-center')}>
        <h3 {...className('heading')} data-testid="option">
          {' '}
          {filter.heading}{' '}
        </h3>
        <ButtonViewGlossary
          glossarySection={
            modelKey === STYLE_BOX_MODELS.EQUITIES ? 'Equities Style Box' : 'Bond Style Box'
          }
          isScreener
          solid
        />
      </Row>
      <div {...className('xContainer')}>
        <p {...className('label', 'xLabel')}>{filter.xLabel}</p>
        <Row {...className('xDescriptors')}>
          {filter.xDescriptors.map((item, index) => {
            return (
              <div data-key={`${item.srText || ''}-${index}`} key={`${item.srText || ''}-${index}`}>
                <div
                  {...className('style-box-xLabel', 'label', item.style)}
                  aria-label={item.srText}
                  data-testid="columnheader"
                >
                  {item.value}
                </div>
              </div>
            );
          })}
        </Row>
      </div>
      <Row {...className('align-items-center', 'yContainer')}>
        <div {...className('yLabel', 'label')}>{filter.yLabel}</div>
        <div {...className('yDescriptors')}>
          {filter.yDescriptors.map((item, index) => {
            return (
              <div
                aria-label={item.srText}
                data-key={`${item.srText || ''}-${index}`}
                data-testid="rowheader"
                key={`${item.srText || ''}-${index}`}
                {...className('style-box-yLabel', 'label', item.style)}
              >
                {item.value}
              </div>
            );
          })}
        </div>
        <div {...className('boxContainer')}>
          {filter.selectors.map((itemX, indexX) => (
            <Row data-key={`${itemX.length}-${indexX}`} key={`${itemX.length}-${indexX}`}>
              {itemX.map((itemY, indexY) => {
                return (
                  <div data-key={`${itemY}-${indexY}`} key={`${itemY}-${indexY}`}>
                    <InteractiveElement
                      {...className('box', !itemY && 'unSelectedBox')}
                      aria-label={filter.srText[indexX][indexY]}
                      aria-checked={itemY}
                      onClick={() => updateValue(modelKey, indexX, indexY)}
                      role="checkbox"
                      tabIndex={0}
                    ></InteractiveElement>
                  </div>
                );
              })}
            </Row>
          ))}
        </div>
      </Row>
    </Col>
  );
};

StyleBox.propTypes = {
  modelKey: PropTypes.string,
  filter: PropTypes.shape({
    heading: PropTypes.string,
    selectors: PropTypes.array,
    srText: PropTypes.array,
    xLabel: PropTypes.string,
    xDescriptors: PropTypes.array,
    yLabel: PropTypes.string,
    yDescriptors: PropTypes.array,
    styleBoxSrText: PropTypes.string,
    fieldKey: PropTypes.string
  }),
  updateValue: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
  return {
    filter: state.filterReducer.filters.styleBoxes[ownProps.modelKey]
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateValue: (modelKey, xIndex, yIndex) => dispatch(styleBoxUpdate(modelKey, xIndex, yIndex))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StyleBox);
